import './polyfills';

import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import jwtDecode from 'jwt-decode';

import App from './components/App';
import store from './store';
import setAuthorizationToken from './utils/setAuthorizationToken';
import { validateUser } from './store/auth/actions';
import './styles/styles.css';


//set auth user based off token if it exists
const token = localStorage.getItem('token')
if (token) {
	const decodedToken = jwtDecode(token);
	setAuthorizationToken(token);
	store.dispatch(validateUser(decodedToken.data.user, token));	
}

ReactDOM.render((
	<Provider store={store}>
		<Router>
			<App />
		</Router>
	</Provider>
), document.getElementById('root'));


// WEBPACK FOOTER //
// ./src/index.js